module.exports = __webpack_public_path__ + "img/noEvidence.9eb1b025.png";